/*
 * @Author: 范朝阳
 * @Date: 2020-05-03 10:39:45
 * @LastEditTime: 2021-01-27 11:23:36
 * @LastEditors: 赵健
 * @Description: In User Settings Edit
 * @FilePath: \trunk\src\utils\request.js
 */
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import Qs from 'qs'
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000, // request timeout
  paramsSerializer: function(params) {
    return Qs.stringify(params, { arrayFormat: 'comma' })
  }
})
/*
* 批量处理分页 序号问题
 */
function handlePage(res) {
  if (res.data && res.data.list && res.data.page && res.data.page.total) {
    // const total = res.data.page.total
    const pageSize = res.data.page.pageSize
    const pageNum = res.data.page.pageNum
    res.data.list.forEach((item, index) => {
      item.xh = index + pageSize * (pageNum - 1) + 1
    })
  }
  return res
}
// 下载文件
function createLink(response) {
  const data = response.data
  const blob = new Blob([data], { type: response.headers['content-type'] })
  const blobUrl = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.download = decodeURI(response.headers['filename']) || '文件.xls'
  a.href = blobUrl
  a.click()
}
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // console.log('0.0', config)
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  async response => {
    let res = response.data
    if (typeof res === 'object' && res instanceof Blob) {
      if (res.type === 'application/json') {
        await new Promise((resolve, reject) => {
          var reader = new FileReader()
          reader.addEventListener('loadend', function(e) {
            res = JSON.parse(e.target.result)
            resolve()
          })
          reader.readAsText(res)
        })
      } else {
        createLink(response)
        return false
      }
    }
    // return Promise.resolve(666)
    // 3003	资源找不到
    // 3006	token刷新
    // console.log(response)
    // return res
    if (process.env.NODE_ENV === 'development') {
      // return handlePage(res)
    }
    // || process.env.NODE_ENV === 'development'
    if (res.code === 3001) { // 成功
      return handlePage(res)
    }

    if (res.code === 3002) { // 失败
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res)
    }
    if (res.code === 3004 || res.code === 3006) { // 3004 未登录 3006 token刷新
      store.dispatch('user/resetToken').then(() => {
        location.reload()
      })
      Message({
        message: '未登录',
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(res)
    }
    if (res.code === 3005) { // 无权限
      Message({
        message: '无权限',
        type: 'error',
        duration: 5 * 1000,
        onClose: function() {
          // location.reload()
        }
      })
      return Promise.reject(res)
    }
    if (res.msg) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(res)
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      // message: error.message,
      message: '网络错误',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

// 增加中间层
export default service
